import React from 'react';
import { Card, Row, Col, Alert, Timeline, Tag, Divider } from 'antd';
import { motion } from 'framer-motion';
import { 
  InboxOutlined,
  ThunderboltOutlined,
  DollarOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

const SmallParcelService: React.FC = () => {
  return (
    <section id="small-parcel" style={{ 
      padding: '80px 0', 
      background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      color: 'white',
      position: 'relative'
    }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', marginBottom: '60px' }}
        >
          <h2 className="display-medium" style={{ 
            marginBottom: '24px',
            color: 'white'
          }}>
            空派专线小货需求和风险
          </h2>
          <p className="body-large" style={{ 
            color: 'rgba(255, 255, 255, 0.9)', 
            maxWidth: '800px', 
            margin: '0 auto',
            fontSize: '1.125rem'
          }}>
            专业的小货处理方案，权衡优势与风险，为客户提供最佳选择
          </p>
        </motion.div>

        <Row gutter={[32, 32]}>
          {/* 美国专线走小货优势 */}
          <Col xs={24} lg={12}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Card
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: 'none',
                  borderRadius: '16px',
                  height: '100%'
                }}
                bodyStyle={{ padding: '32px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <CheckCircleOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
                  <h3 style={{ 
                    color: '#1D1D1F',
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    marginBottom: '16px'
                  }}>
                    美国专线走小货优势
                  </h3>
                </div>

                <Timeline
                  items={[
                    {
                      dot: <ThunderboltOutlined style={{ fontSize: '16px', color: '#1890ff' }} />,
                      children: (
                        <div>
                          <h4 style={{ color: '#1890ff', margin: '0 0 8px 0' }}>清关模式优势</h4>
                          <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
                            可以通过专线渠道做T01大贸正式清关模式，解决T86清关和快件清关受限问题
                          </p>
                        </div>
                      )
                    },
                    {
                      dot: <DollarOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                      children: (
                        <div>
                          <h4 style={{ color: '#52c41a', margin: '0 0 8px 0' }}>成本优势</h4>
                          <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
                            相对传统快递渠道，专线价格更低，容易做包税方式
                          </p>
                        </div>
                      )
                    }
                  ]}
                />

                <Alert
                  message="小货服务优势"
                  description="318空派专线在小货处理方面具备显著的成本和清关优势"
                  type="success"
                  showIcon
                  style={{ marginTop: '20px' }}
                />
              </Card>
            </motion.div>
          </Col>

          {/* 风险点分析 */}
          <Col xs={24} lg={12}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Card
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: 'none',
                  borderRadius: '16px',
                  height: '100%'
                }}
                bodyStyle={{ padding: '32px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <WarningOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
                  <h3 style={{ 
                    color: '#1D1D1F',
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    marginBottom: '16px'
                  }}>
                    风险点
                  </h3>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <Alert
                    message="品名申报风险"
                    description="小货品名杂，提供的货物信息不一定准确，出口买单报关风险比较大，一旦碰到海关查验有退仓风险"
                    type="warning"
                    showIcon
                    style={{ marginBottom: '16px' }}
                    icon={<ExclamationCircleOutlined />}
                  />
                  
                  <Alert
                    message="清关查验风险"
                    description="美国整体查验率很低，但是小货在清关方面，由于品名比较杂，还是担心查验风险，怕海关针对包中包的问题提出质疑"
                    type="error"
                    showIcon
                    icon={<WarningOutlined />}
                  />
                </div>

                <div style={{ 
                  background: '#fff7e6', 
                  padding: '16px', 
                  borderRadius: '8px',
                  border: '1px solid #ffe58f'
                }}>
                  <h4 style={{ color: '#d48806', marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
                    <InfoCircleOutlined style={{ marginRight: '8px' }} />
                    注意事项
                  </h4>
                  <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
                    <strong>建议：</strong>尽量接快递渠道的小货和品名比较单一的小包货，杂货不建议收
                  </p>
                </div>
              </Card>
            </motion.div>
          </Col>
        </Row>

        {/* 常用派送方式 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          style={{ marginTop: '60px' }}
        >
          <Card
            style={{
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: 'none',
              borderRadius: '16px'
            }}
            bodyStyle={{ padding: '40px' }}
          >
            <h3 style={{ 
              textAlign: 'center', 
              marginBottom: '32px',
              color: '#1D1D1F',
              fontSize: '1.5rem',
              fontWeight: '600'
            }}>
              常用派送方式
            </h3>

            <Row gutter={[32, 32]}>
              <Col xs={24} md={12}>
                <div style={{ 
                  background: '#f0f9ff', 
                  padding: '24px', 
                  borderRadius: '12px',
                  border: '2px solid #1890ff',
                  height: '100%'
                }}>
                  <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <InboxOutlined style={{ fontSize: '40px', color: '#1890ff', marginBottom: '12px' }} />
                    <h4 style={{ color: '#1890ff', margin: 0 }}>UPS Ground为主</h4>
                  </div>
                  <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                    <p><Tag color="green">优势</Tag> 单件价格低，打小货有优势</p>
                    <p><Tag color="red">缺点</Tag> 超重、超尺寸附加费比较高</p>
                  </div>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={{ 
                  background: '#fff2e8', 
                  padding: '24px', 
                  borderRadius: '12px',
                  border: '2px solid #faad14',
                  height: '100%'
                }}>
                  <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <ThunderboltOutlined style={{ fontSize: '40px', color: '#faad14', marginBottom: '12px' }} />
                    <h4 style={{ color: '#faad14', margin: 0 }}>FedEx MWT大货价格为主</h4>
                  </div>
                  <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                    <p><Tag color="green">优势</Tag> 500LBS以上全美派送价格都有优势</p>
                    <p><Tag color="red">缺点</Tag> 部分亚马逊仓库派送不稳定，经常暂停派送</p>
                  </div>
                </div>
              </Col>
            </Row>

            <Divider style={{ margin: '32px 0' }} />

            <div style={{ 
              background: '#f6ffed', 
              padding: '24px', 
              borderRadius: '12px',
              border: '1px solid #b7eb8f'
            }}>
              <h4 style={{ color: '#52c41a', marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                <CheckCircleOutlined style={{ marginRight: '8px' }} />
                大货、托盘、木箱等货物
              </h4>
              <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
                <p>• <strong>派送方式：</strong>主要用卡车派送，派送地址比较近的使用本地专车</p>
                <p>• <strong>跨州派送：</strong>使用LTL卡车，有第三方轨迹追踪</p>
                <p style={{ margin: 0 }}>• <strong>安全保障：</strong>专业的大件货物处理经验，确保货物安全</p>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>

      {/* 背景装饰 */}
      <div style={{
        position: 'absolute',
        top: '15%',
        right: '0%',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }} />
      
      <div style={{
        position: 'absolute',
        bottom: '15%',
        left: '-8%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }} />
    </section>
  );
};

export default SmallParcelService;
